// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"9042e3a1","321":"4e49ac03","328":"87ff7582","352":"0283a589","557":"1d45cfd0","566":"051cc50d","796":"eb5cfc06"}[chunkId] + ".chunk.css";
};